var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"loadRecaptchaScript":true,"sitekey":this.info.googleRecaptchaToken},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})}
var staticRenderFns = []

export { render, staticRenderFns }